import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import contactImg from "../../assets/contect4.jpg";

const Contact = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <div
          className="contact-section d-flex align-items-center py-5"
          style={{
            backgroundImage: `url(${contactImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            minHeight: "100vh",
          }}
          data-aos="zoom-in"
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              // backgroundColor: "rgba(179, 173, 173, 0.61)",
              zIndex: 1,
            }}
          />

          <Container style={{ position: "relative", zIndex: 2 }} fluid>
            <Row className="justify-content-start">
              <Col md={10} lg={7} data-aos="fade-right">
                <div
                  className="p-4 p-md-5 rounded-4  "
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.41)",
                  }}
                >
                  <h2 className="mb-4 text-light">
                    Request a Free Consultation
                  </h2>

                  <Form>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control
                            type="text"
                            placeholder="Your Name"
                            className="form-control-md"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formEmail">
                          <Form.Control
                            type="email"
                            placeholder="Email Address"
                            className="form-control-md"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formPhone">
                          <Form.Control
                            type="number"
                            placeholder="Phone Number"
                            className="form-control-md"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formDate">
                          <Form.Control
                            type="date"
                            className="form-control-md"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formAge">
                          <Form.Select className="form-control-md">
                            <option>Select Age</option>
                            {[...Array(100)].map((_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3" controlId="formSubject">
                          <Form.Select className="form-control-md">
                            <option>Select Subject</option>
                            <option value="business">
                              Business Consultation
                            </option>
                            <option value="technical">Technical Support</option>
                            <option value="career">Career Advice</option>
                            <option value="other">Other</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="formMessage">
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Your message"
                        className="form-control-md"
                      />
                    </Form.Group>
                    <div>
                      <Button type="submit" className="quote-button btn-lg">
                        Send Message
                      </Button>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Contact;
